// jshint esversion: 8

export default {
  valueRule: message => v => !!v || message,
  regexRule: (regex, message) => v => !!regex.test(v) || message
};
